import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import partial from 'lodash/partial';
import idx from 'idx';
import { getProject } from 'project/ducks/project';
import { getSubcategorySlug } from 'common/ducks/categories';
import { giveFeedback, dismissFeedback } from 'entries/ducks';
import NegativeFeedback from 'entries/components/negative_feedback';

const validate = (values) => {
  const errors = {};

  if (values.feedbackTextCheckbox && !values.feedback) {
    errors.feedback = 'Please enter some feedback';
  }

  if (values.feedback && !values.feedback.trim()) {
    errors.feedback = 'Please enter some feedback';
  }

  return errors;
}

const mapStateToProps = (state) => {
  return {
    subcatSlug: getSubcategorySlug(state.categories, idx(getProject(state), _ => _.sub_category))
  };
}

const mapDispatchToProps = (dispatch, { item }) => {
  return bindActionCreators({
    onSubmit: partial(giveFeedback, item),
    onHide: dismissFeedback,
  }, dispatch);
}

const NegativeFeedbackForm = reduxForm({
  form: 'REVISION_FEEDBACK_NEGATIVE',
  validate,
})(NegativeFeedback);

export default connect(mapStateToProps, mapDispatchToProps)(NegativeFeedbackForm);



// WEBPACK FOOTER //
// ./entries/containers/negative_feedback.js